export const COUNTERPARTY_MASTER_DATA_INITIAL_LOAD = "COUNTERPARTY_MASTER_DATA_INITIAL_LOAD";

export const loadInitialCounterpartyMasterData = (data) => {
    return {
        type: COUNTERPARTY_MASTER_DATA_INITIAL_LOAD,
        data
    }
}